import { render, staticRenderFns } from "./MisMateriasGratis.vue?vue&type=template&id=75b6c06d&scoped=true"
import script from "./MisMateriasGratis.vue?vue&type=script&lang=js"
export * from "./MisMateriasGratis.vue?vue&type=script&lang=js"
import style0 from "./MisMateriasGratis.vue?vue&type=style&index=0&id=75b6c06d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b6c06d",
  null
  
)

export default component.exports